import { createStore, applyMiddleware, Store } from "redux";
import reducer, { RootState } from "./reducers";
import { CHOICES_KEY } from "./constants/LocalStorage";
import { saveState, loadState } from "./persistState";
import { addChoice } from "./actions/choiceActions";
import { addDisabled } from "./actions/disabledActions";
import { addHidden } from "./actions/hiddenActions";
import conditionsMiddleware from "./middleware/conditions";
import { ActionPayload, Entities } from "../types";
import getFormData from "../helpers/getFormData";

const data = getFormData();

const postId = "ID" in data.post ? data.post.ID : "";
const postModified =
  "post_modified_gmt" in data.post ? data.post.post_modified_gmt : "";
const { app_version } = data;
const storageKey = `${CHOICES_KEY}_${postId}`;

const loadDefaults = (
  entities: Entities,
  s: Store<RootState, ActionPayload<any>>
) => {
  const { parts, sections } = entities;
  const { byId, allIds } = parts;

  allIds.forEach((id) => {
    const part = byId[id];
    if (!part) return;
    const sectionId = part.sectionId;
    const section = sections.byId[sectionId];
    if (!section) return;
    if (part.default === "selected") {
      s.dispatch(addChoice(part));
    }
    if (part.default === "disabled") {
      s.dispatch(addDisabled(id));
    }
    if (part.default === "hidden") {
      s.dispatch(addHidden(id));
    }
  });
};
const persisted = loadState(storageKey, postModified, app_version);
const store = createStore(
  reducer,
  persisted,
  applyMiddleware(conditionsMiddleware)
);

if (!persisted) loadDefaults(data.entities, store);

store.subscribe(() => {
  const choices = store.getState().choices;
  const hidden = store.getState().hidden;
  const disabled = store.getState().disabled;
  const packaged = store.getState().packaged;
  saveState(storageKey, {
    lastModified: postModified,
    appVersion: app_version,
    choices,
    hidden,
    disabled,
    packaged,
  });
  console.log(store.getState());
});

export default store;
